<template>
  <div :class="$style.scheduleChangePrice">
    <div :class="$style.btnDisplay">
      <div>
        <el-button class="is-round is-border" :class="[$style.scheduleChangePrice__addBtn]" type="primary"
          @click="sameAsFirstRowBtn">
          指定抽成皆同第一列
        </el-button>
        <el-button class="is-round is-border" :class="$style.scheduleChangePrice__addBtn" plain @click="resetChangePrice">
          重置
        </el-button>
      </div>
      <el-button class="is-round is-border" :class="$style.scheduleChangePrice__addBtn" plain
        @click="addChangePricePerson">
        <BaseIcon name="plus" />
        新增變價人員
      </el-button>
    </div>
    <transition-group type="transition">
      <el-collapse v-for="(item, index) in changePriceItems" :key="index" v-model="collapseActiveNames"
        class="custom-collapse isStyleLimit is-border is-round" style="margin-bottom: 10px">
        <el-collapse-item style="border:0" :name="`${index}`" @click.self="">
          <div slot="title" class="el-collapse-title d-flex align-items-center justify-content-between">
            <span>
              {{ item.name }} {{ item.title }}
            </span>
            <BaseIcon @click.stop.native="deleteCollapseItem(item, index)" name="trash-alt" />
          </div>
          <div :class="$style['scheduleChangePrice__parentServiceList']">
            <div @click.self="selectedItem(sizeItem)" v-for="(sizeItem, index) in item['sizePrices']"
              :key="`${item.id}${index}`"
              :class="[$style['scheduleChangePrice__serviceList'], sizeItem.selectedStatus ? 'borderColor' : 'borderNormal']">
              <div :class="$style['scheduleChangePrice__serviceList__title']">
                <p @click.self="selectedItem(sizeItem)">{{ sizeItem.sizeTitle }}</p>
                <p @click.self="selectedItem(sizeItem)">{{ sizeItem.storeTitle }}</p>
              </div>
              <div :class="$style['scheduleChangePrice__serviceList__numberDisplay']">
                <div :class="$style['scheduleChangePrice__serviceList__Input']">
                  <span :class="$style['scheduleChangePrice__serviceList__Input__aboveSpan']">服務變價：</span>
                  <el-input :class="$style['scheduleChangePrice__serviceList__Input__aboveInput']"
                    @focus.prevent="focusItem(sizeItem)" v-model.number="sizeItem.changePriceNumber" type="number" />
                  <span>元</span>
                </div>
                <div :class="$style['scheduleChangePrice__serviceList__commissionDisplay']">
                  <div :class="$style['scheduleChangePrice__serviceList__Input']">
                    <span :class="$style['scheduleChangePrice__serviceList__Input__belowSpan']">以美容師抽成：</span>
                    <el-input :class="$style['scheduleChangePrice__serviceList__Input__belowInput']"
                      @focus.prevent="focusItem(sizeItem)" v-model.number="sizeItem.commission_value" type="number" />
                    <span :class="$style['scheduleChangePrice__serviceList__Input__dollar']">元</span>
                  </div>
                  <div :class="$style['scheduleChangePrice__serviceList__Input']">
                    <span :class="$style['scheduleChangePrice__serviceList__Input__belowSpan']">以助理抽成：</span>
                    <el-input :class="$style['scheduleChangePrice__serviceList__Input__belowInput']"
                      @focus.prevent="focusItem(sizeItem)" v-model.number="sizeItem.helper_commission_value"
                      type="number" />
                    <span :class="$style['scheduleChangePrice__serviceList__Input__dollar']">元</span>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </transition-group>
    <el-dialog :title="`新增變價人員`" :visible.sync="dialogPriceVisiable" width="80%" top="0" append-to-body>
      <DialogTemplate :placeholder="`變價人員姓名`" :dialogType="`person`" :editCheckInList="editCheckInList"
        :itemList="dialogPriceList" @save="childPriceSave" @cancel="dialogPriceVisiable = false" />
    </el-dialog>
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
import { cloneDeep } from 'lodash'
export default {
  name: 'TabScheduleChangePrice',
  data() {
    return {
      dialogPriceVisiable: false, // 新增變價人員的視窗
      dialogServiceVisiable: false, // 新增變價服務視窗
      dialogPriceList: [], // 所有人
      dialogServiceList: cloneDeep(this.defaultValue.petSizes), // 所有服務
      changePriceItems: [], // 變價items
      changeServiceItems: [], // 服務items
      collapseActiveNames: []
    };
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    // 畫面上使用者有操作的資料
    changePriceItems: {
      handler(nvl) {
        this.$emit('updateChangePrice', nvl)
      },
      deep: true
    }
  },
  computed: {
    editMode() {
      if (this.defaultValue.customServicePrices.length === 0) {
        return false
      } else {
        return true
      }
    },
    /**
     * @description 開啟新增變價人員視窗要讓裡外同步
     */
    editCheckInList() {
      if (this.defaultValue.customServicePrices.length > 0) {
        return this.defaultValue.customServicePrices.map(item => item.scheduleItemId)
      }
    }
  },
  created() { },
  async mounted() {
    if (!this.editMode) {
      this.dialogServiceList.forEach(item => {
        item.changePriceNumber = 0
        item.commission_value = null
        item.helper_commission_value = null
        item.selectedStatus = false
      })
    } else {
      this.editModeInit()
    }
  },
  methods: {
    /**
     * @description 重置變價
     */
    resetChangePrice() {
      this.changePriceItems.forEach(changePriceItem => {
        const { sizePrices } = changePriceItem
        sizePrices.forEach(sizePrice => {
          this.$set(sizePrice, 'changePriceNumber', 0)
          this.$set(sizePrice, 'commission_value', null)
          this.$set(sizePrice, 'helper_commission_value', null)
        })
      })
    },
    /**
     * @description 指定抽成皆同第一列
     */
    sameAsFirstRowBtn() {
      if (this.changePriceItems.length > 1) {
        const { sizePrices } = this.changePriceItems[0]
        const sizePriceObj = sizePrices.reduce((accu, cur) => {
          accu[cur.id] = {
            id: cur.id,
            changePriceNumber: cur.changePriceNumber,
            commission_value: cur.commission_value,
            helper_commission_value: cur.helper_commission_value,
          }
          return accu
        }, {})
        for (let i = 1, len = this.changePriceItems.length; i < len; i++) {
          const { sizePrices } = this.changePriceItems[i]
          sizePrices.forEach(sizePrice => {
            if (sizePrice.id in sizePriceObj) {
              this.$set(sizePrice, 'changePriceNumber', sizePriceObj[sizePrice.id]['changePriceNumber'] || null)
              this.$set(sizePrice, 'commission_value', sizePriceObj[sizePrice.id]['commission_value'] || null)
              this.$set(sizePrice, 'helper_commission_value', sizePriceObj[sizePrice.id]['helper_commission_value'] || null)
            }
          })
        }
      }
    },
    /**
     * @description 刪除變價人員
     */
    async deleteCollapseItem(item, index) {
      try {
        const result = await this.$confirm('請問是否要刪除此變價人員設定', '提示', {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
        if (result === 'confirm') {
          this.changePriceItems.splice(index, 1)
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    initChangePriceNumber(list) {
      list.forEach(item => {
        item.changePriceNumber = 0
        item.commission_value = null
        item.helper_commission_value = null
        item.selectedStatus = false
      })
      return list
    },
    /**
     * @description 如果已經有初始資料，則走這邊
     */
    async editModeInit() {
      try {
        // 先搜尋所有人員（拿到名字
        this.dialogPriceList = await this.$store.dispatch('schedule/fetchStaff', {
          type: 'cosmetic',
          paginate: 0
        })
        // 再來取得已經有變價的人員
        this.defaultValue.customServicePrices.forEach(item => {
          // 找出編輯的人員
          const editItem = this.dialogPriceList.find(scheduleItem => scheduleItem.id === item.scheduleItemId)
          // 組出編輯畫面的價錢
          const editPriceList = this.initChangePriceNumber(cloneDeep(this.dialogServiceList))
          editPriceList.forEach(priceItem => {
            item.servicePrices.forEach(innerItem => {
              if (innerItem.servicePriceId === priceItem.id) {
                priceItem.changePriceNumber = innerItem.price
                priceItem.commission_value = innerItem.commission_value
                priceItem.helper_commission_value = innerItem.helper_commission_value
                priceItem.selectedStatus = true
              }
            })
          })
          this.$set(editItem, 'sizePrices', editPriceList)
          this.changePriceItems.push(editItem)
        })
      } catch (error) {
        console.error(error.message)
      }

    },
    /**
     * @description 新增變價人員
     */
    async addChangePricePerson() {
      try {
        if (!this.isEditMode) {
          this.dialogPriceList = await this.$store.dispatch('schedule/fetchStaff', {
            type: 'cosmetic',
            paginate: 0
          })
        }
        this.dialogPriceVisiable = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 選取人員之後回來之後做的事
     */
    childPriceSave(selectData) {
      try {
        const oldData = this.changePriceItems.map(item => item.id) // 畫面上的id們(原始資料)
        const newData = selectData // 使用者選到的資料
        let addedItems = new Set(newData.filter(x => !oldData.includes(x)));
        let removedItems = new Set(oldData.filter(x => !newData.includes(x)));
        addedItems.forEach(item => {
          const rawList = cloneDeep(this.dialogServiceList)
          const person = this.dialogPriceList.find(listItem => listItem.id === item)
          this.$set(person, 'sizePrices', this.initChangePriceNumber(rawList))
          this.changePriceItems.push(person)
        })
        removedItems.forEach((idItem) => {
          const indexToRemove = this.changePriceItems.findIndex(item => item.id === idItem)
          if (indexToRemove > -1) {
            this.changePriceItems.splice(indexToRemove, 1); // 從索引位置 3 開始刪除 1 個元素  
          }
        })
        this.dialogPriceVisiable = false
      } catch (error) {
        console.error(error.message)
      }

    },
    handleCollapseChange(val) {
    },
    /**
     * @description 新增變價服務
     */
    addChangePriceService() {
      this.dialogServiceVisiable = true
    },
    selectedItem(item) {
      this.$set(item, 'selectedStatus', !item.selectedStatus)
    },
    /**
     * @description click el-input 讓他加減同時，順便幫他selected起來
     */
    focusItem(nvl) {
      if (!nvl.selectedStatus) {
        this.$set(nvl, 'selectedStatus', true)
      }

    },
  },
  components: {
    DialogTemplate: () => lazyLoadComponent(import('./DialogTemplate')),
  },
};
</script>

<style lang="scss" module>
.btnDisplay {
  display: flex;
  justify-content: space-between;
}

.scheduleChangePrice {
  padding: 20px;
  background-color: white;

  :global {
    .borderColor {
      border-color: $color-primary;
    }

    .borderNormal {
      border-color: $color-line-dark;
    }
  }

  &__addBtn {
    margin-bottom: 20px;
    width: 250px;
  }

  &__collapseBtn {
    margin-bottom: -10px;
  }

  &__parentServiceList {
    display: flex;
    flex-wrap: wrap;

  }

  &__serviceList {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    border: 1px solid;
    display: flex;
    margin: 10px;
    height: 125px;
    border-radius: $border-radius;
    justify-content: flex-start;
    align-items: center;

    &__numberDisplay {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &__commissionDisplay {
      display: flex;
      margin-top: 10px;
      justify-content: space-between;
    }

    &__title {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      >p {
        margin-top: 5px;
        margin-bottom: 5px;
      }
    }

    &__Input {
      display: flex;
      align-items: center;

      &__aboveSpan {
        display: inline-block;
        margin: 0 10px;
        width: 80px;
      }

      &__aboveInput {
        width: 90%;
        margin-right: 10px;
      }

      &__belowInput {
        width: 85%;
        margin-right: 10px;
      }

      &__belowSpan {
        display: inline-block;
        margin: 0 10px;
        width: 160px;
      }

      &__dollar {
        display: inline-block;
      }
    }
  }
}
</style>
